import React, { useEffect, useState } from 'react';
import * as S from './Table.styled';
import { Table as TableAnt } from 'antd';
import { ITableProps } from 'features/FavouritesList/interfaces';
import dayjs from 'dayjs';
import { ColumnsType } from 'antd/lib/table';
import { TablePaginationConfig } from 'antd/lib/table/interface';
import { IFavourite, IUser, ILot, IComplex } from 'interfaces/main';
import type { FilterValue, SortOrder, SorterResult } from 'antd/es/table/interface';
import { numberWithCommas } from 'utils/help';

interface TableParams {
	pagination?: TablePaginationConfig;
	sortField?: string;
	sortOrder?: SortOrder;
	filters?: Record<string, FilterValue>;
}

const Table: React.FC<ITableProps> = ({ items }) => {
	// Table params
	const [tableParams, setTableParams] = useState<TableParams>({
		pagination: {
			current: 1,
			pageSize: 10,
			total: 0,
		},
		// sortField: "createdAt",
		// sortOrder: "descend",
	});

	useEffect(
		() =>
			setTableParams({
				...tableParams,
				pagination: {
					...tableParams.pagination,
					total: items.length,
				},
			}),
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[items],
	);

	// const emails = uniq(items.map((item: IFavourite) => item.email)).map(
	//   (email: string) => ({ text: email, value: email }),
	// );

	// const phones = uniq(items.map((item: IFavourite) => item.phone)).map(
	//   (phone: string) => ({ text: phone, value: phone }),
	// );

	// const users = uniq(items.map((item: IUser) => item.name)).map(
	//   (name: string) => ({ text: name, value: name }),
	// );

	// Конфиг таблички для Ant Table
	const columns: ColumnsType<IFavourite> = [
		{
			title: 'Date',
			dataIndex: 'createdAt',
			key: 'createdAt',
			ellipsis: true,
			sorter: (a: IFavourite, b: IFavourite) =>
				dayjs(a.createdAt).valueOf() - dayjs(b.createdAt).valueOf(),
			defaultSortOrder: 'descend',
			render: (createdAt: string) => dayjs(createdAt).format('DD.MM.YYYY HH:mm'),
			width: 150,
		},
		{
			title: 'Name',
			dataIndex: 'user',
			key: 'name',
			render: (user: IUser) => user?.name || '-',
		},
		{
			title: 'Email',
			dataIndex: 'user',
			key: 'email',
			render: (user: IUser) => user?.email || '-',
		},
		{
			title: 'Phone',
			dataIndex: 'user',
			key: 'phone',
			render: (user: IUser) => user?.phone || '-',
		},
		{
			title: 'Complex',
			dataIndex: 'complex',
			key: 'complexName',
			render: (complex: IComplex) => complex?.title || '-',
		},
		{
			title: 'Lot',
			dataIndex: 'lot',
			key: 'title',
			render: (lot: ILot) => lot?.unit || '-',
		},
		{
			title: 'Price',
			dataIndex: 'lot',
			key: 'price',
			render: (lot: ILot) => (lot?.price ? `${numberWithCommas(lot.price)} USD` : '-'),
		},
		{
			title: 'Total area',
			dataIndex: 'lot',
			key: 'totalArea',
			render: (lot: ILot) => (lot?.totalArea ? `${numberWithCommas(lot.totalArea)} sqft` : '-'),
		},
		// {
		//   title: 'Link',
		//   dataIndex: 'id',
		//   key: 'lotId',
		//   render: (id: number) => (
		//     <Link
		//       href={`https://www.bayut.com/property/details-${id}.html`}
		//       target="_blank">
		//       Advert
		//     </Link>
		//   ),
		// },
	];

	const handleTableChange = (
		pagination: TablePaginationConfig,
		filters: Record<string, FilterValue>,
		sorter: SorterResult<IFavourite>,
	) => {
		setTableParams({
			pagination,
			filters,
			...sorter,
		});
	};

	return (
		<S.Wrap>
			<TableAnt
				columns={columns}
				rowKey={(request: IFavourite) => request.id}
				dataSource={items}
				pagination={items.length > 10 ? tableParams.pagination : false}
				onChange={handleTableChange}
			/>
		</S.Wrap>
	);
};

export default Table;
